export default __webpack_public_path__ + "static/media/hadco-staffing-solutions-logo.3d86dcff.png";